<template>
  <div class="flex flex-col">
    <div class="relative">
      <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <slot name="icon" />
      </div>

      <input
        v-bind="$attrs"
        v-model="inputValue"
        type="text"
        :name="$props.name"
        class="pl-10 pr-3 form-input"
      >
    </div>

    <span
      v-if="error"
      class="text-red-600 text-sm"
    >{{ error }}</span>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

withDefaults(
  defineProps<{
    name: string;
    error?: string;
  }>(),
  {
    error: undefined,
  },
);

defineOptions({
  inheritAttrs: false,
});

const inputValue = defineModel();
const inputRef = ref<HTMLInputElement>();

const focusInput = () => {
  inputRef.value?.focus();
};

const blur = () => {
  inputRef.value?.blur();
};

defineExpose({
  focusInput,
  blur,
});
</script>

<style scoped></style>
